import View from './TransactionsFilter.view';

export default View;
